<template>
  <CreateEditSurveyFormModal
    v-if="showCreateEditSurveyFormModal"
    :surveyId="surveyId"
    :nextOrder="nextOrder"
    :surveyFormId="surveyFormIdSelected"
    @closeModal="closeModal"
  />
  <DeleteSurveyFormModal
    v-if="showDeleteSurveyFormModal"
    :surveyId="surveyId"
    :surveyFormId="surveyFormIdSelected"
    @closeModal="closeModal"
  />
  <LoadingData v-if="isLoadingData" class="my-3" />
  <template v-else>
    <div class="card-body text-end">
      <button
        type="button"
        class="btn btn-primary"
        title="Cadastrar Pergunta"
        @click="createEditSurveyForm()"
      >
        Cadastrar Pergunta
      </button>
    </div>
    <ListSurveyForms
      :surveyForms="surveyForms"
      @createEditSurveyForm="createEditSurveyForm"
      @deleteSurveyForm="deleteSurveyForm"
    />
  </template>
</template>

<script>
import CreateEditSurveyFormModal from '@/components/params/surveys/forms/CreateEditSurveyFormModal.vue'
import DeleteSurveyFormModal from '@/components/params/surveys/forms/DeleteSurveyFormModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListSurveyForms from '@/components/params/surveys/forms/ListSurveyForms.vue'

export default {
  name: 'FormsSurvey',

  props: {
    surveyId: {
      type: String,
      required: true,
    },
  },

  components: {
    CreateEditSurveyFormModal,
    DeleteSurveyFormModal,
    LoadingData,
    ListSurveyForms,
  },

  data() {
    return {
      isLoadingData: true,
      showCreateEditSurveyFormModal: false,
      showDeleteSurveyFormModal: false,
      surveyForms: [],
      surveyFormIdSelected: null,
      nextOrder: 1,
    }
  },

  methods: {
    async getSurveyForms() {
      try {
        this.surveyForms = await this.$store.dispatch('getSurveyForms', {
          surveyId: this.surveyId,
        })

        this.nextOrder =
          this.surveyForms.length > 0
            ? Number(this.surveyForms[this.surveyForms.length - 1].order) + 1
            : 1

        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    createEditSurveyForm(surveyFormId) {
      this.surveyFormIdSelected = surveyFormId || null
      this.showCreateEditSurveyFormModal = true
    },

    deleteSurveyForm(surveyFormId) {
      this.surveyFormIdSelected = surveyFormId
      this.showDeleteSurveyFormModal = true
    },

    closeModal(needReload) {
      if (needReload) {
        this.isLoadingData = true
        this.getSurveyForms()
      }
      this.showCreateEditSurveyFormModal = false
      this.showDeleteSurveyFormModal = false
    },
  },

  mounted() {
    this.getSurveyForms()
  },
}
</script>
